/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/*
 * Copyright (c) 2020 AXA Group Operations Spain S.A.
 *
 * Licensed under the AXA Group Operations Spain S.A. License (the "License");
 * you may not use this file except in compliance with the License.
 * A copy of the License can be found in the LICENSE.TXT file distributed
 * together with this file.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Button, Col, Space, Collapse } from 'antd';

import { MESSAGES } from '@translations/labels';
import { useAgentId } from '@hooks/useAgentId';
import { LANGUAGES } from '@languages';
import botSettingsActions from '@store/actions/botSettings';
import { isEmpty } from '@utils/validation/isEmpty';
import UploadBotDataFiles from '../upload-bot-data-files/UploadBotDataFiles';
import { useUpdateBotSettings } from './useUpdateBotSettings';
import { useAddBotSettings } from './useAddBotSettings';

const BotConnectionForm = () => {
  const { Panel } = Collapse;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { agentId } = useAgentId();
  const labels = { ...MESSAGES.manageBot, ...MESSAGES.commons };
  const { TextArea } = Input;
  const { updateBotSettings } = useUpdateBotSettings();
  const { addBotSettings } = useAddBotSettings();
  const botSettings = useSelector(state => state.botSettings.current);

  useEffect(() => {
    if (isEmpty(botSettings)) {
      dispatch(botSettingsActions.getBotSettings(agentId));
    }
  }, [!!botSettings]);
  const setValue = (field, text) => form.setFieldsValue({ [field]: text });

  if (!isEmpty(botSettings)) {
    console.log('incoming botSettings', botSettings);
    setValue('contactData', JSON.stringify(botSettings, null, 2));
  }
  const onReset = () => {
    form.resetFields();
  };

  const validateContent = () => {
    const contactData = form.getFieldValue('contactData');
    let isOk = false;
    let parsedSettings;
    try {
      parsedSettings = JSON.parse(contactData);
      isOk = true;
    } catch (error) {
      console.error('Wrong bot connection format');
      isOk = false;
    }
    console.log('validateContent -> ', isOk);
    return isOk;
  };

  const handleFinish = values => {
    console.log('handleFinish > values -> ', values);
    if (validateContent()) {
      const parsedData = JSON.parse(values.contactData);
      console.log('handleFinish > parsedData -> ', parsedData);
      const dataId = parsedData._id;
      if (dataId) {
        updateBotSettings(dataId, parsedData);
      } else {
        console.error('missing data id. creating news bot settings: ', parsedData);
        addBotSettings(parsedData);
      }
    }
  };
  return (
    <Col span={24}>
      <Form layout="vertical" form={form} onFinish={handleFinish} hideRequiredMark scrollToFirstError>
        <Collapse defaultActiveKey={['1']}>
          <Panel header={labels.formBotConnectionContent} key="1" open="false">
            <Form.Item
              name="contactData"
              validateStatus={validateContent() ? 'success' : 'error'}
              rules={[
                {
                  required: true,
                  message: `${labels.formBotSettingsContent} ${labels.fieldRequired}`,
                },
              ]}
            >
              <TextArea
                placeholder={labels.formInputBotSettingsContentPlaceholder}
                maxLength={1000}
                showCount
                autoSize
                allowClear
              />
            </Form.Item>
          </Panel>
        </Collapse>

        <Form.Item className="text-right">
          <Space size="middle">
            <Button type="primary" htmlType="submit" className="uppercase">
              {labels.formSaveChanges}
            </Button>
          </Space>
        </Form.Item>
      </Form>
      <UploadBotDataFiles />
    </Col>
  );
};

export { BotConnectionForm };
